export default __webpack_public_path__ + "static/media/calc.c1862a53.png";